import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 16 16"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M6.472 2.195c.26.26.26.683 0 .943L4.943 4.667H12A.667.667 0 1 1 12 6H4.943l1.529 1.529a.667.667 0 1 1-.943.942L2.862 5.805a.667.667 0 0 1 0-.943L5.53 2.195c.26-.26.682-.26.943 0M9.529 7.53c.26-.26.682-.26.943 0l2.666 2.666c.26.26.26.683 0 .943l-2.666 2.667a.667.667 0 1 1-.943-.943l1.528-1.529H4A.667.667 0 1 1 4 10h7.057L9.53 8.471a.667.667 0 0 1 0-.942",
      clipRule: "evenodd"
    }
  )
);
var SvgArrowsContractOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ArrowsContractOutlined_default = SvgArrowsContractOutlined;

export { ArrowsContractOutlined_default as default };
